import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './HomeNavbar.css';

function HomeNavbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();

  const isCompanyPage = location.pathname === '/company';
  const isCreatorsPage = location.pathname === '/creator';

  const handleLogout = () => {
    logout();
    navigate('/company');
  };

  return (
    <nav className="home-navbar">
      <div className="home-navbar-container">
        <Link to="/company" className="home-navbar-logo">
          Dstribute
        </Link>

        <div className="home-navbar-center">
          <Link
            to="/company"
            className={`home-navbar-link ${isCompanyPage ? 'active' : ''}`}
          >
            For Company
          </Link>
          <Link
            to="/creator"
            className={`home-navbar-link ${isCreatorsPage ? 'active' : ''}`}
          >
            For Creators
          </Link>
        </div>

        <div className="home-navbar-right">
          {isAuthenticated ? (
            <>
              <button onClick={handleLogout} className="home-navbar-btn home-navbar-btn-secondary">
                Sign Out
              </button>
            </>
          ) : (
            <>
              <Link to="/signin" className="home-navbar-btn home-navbar-btn-secondary">
                Sign In
              </Link>
              <Link to="/signup" className="home-navbar-btn home-navbar-btn-primary">
                Sign Up
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default HomeNavbar;